import React from 'react';

const LoadingSpinner = () => (
  <div className="card">
	<div className="card-body">
		<i className="fa fa-spinner fa-spin" /> Loading...
	</div>
  </div>
);

export default LoadingSpinner;